import { r as f, t as h, a as n } from "./_l10n-f5af5269.mjs";
f(h);
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Grigorii K. Shartsev <me@shgk.me>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class e {
  /**
   * @param {number} r The red value
   * @param {number} g The green value
   * @param {number} b The blue value
   * @param {string} [name] The name of the color
   */
  constructor(t, r, l, a) {
    this.r = t, this.g = r, this.b = l, a && (this.name = a);
  }
}
function b(o, t) {
  const r = new Array(3);
  return r[0] = (t[1].r - t[0].r) / o, r[1] = (t[1].g - t[0].g) / o, r[2] = (t[1].b - t[0].b) / o, r;
}
function i(o, t, r) {
  const l = [];
  l.push(t);
  const a = b(o, [t, r]);
  for (let c = 1; c < o; c++) {
    const u = Math.floor(t.r + a[0] * c), w = Math.floor(t.g + a[1] * c), s = Math.floor(t.b + a[2] * c);
    l.push(new e(u, w, s));
  }
  return l;
}
const g = [
  new e(182, 70, 157, n("Purple")),
  new e(
    191,
    103,
    139,
    n("Rosy brown")
    // TRANSLATORS: A color name for RGB(191, 103, 139)
  ),
  new e(
    201,
    136,
    121,
    n("Feldspar")
    // TRANSLATORS: A color name for RGB(201, 136, 121)
  ),
  new e(
    211,
    169,
    103,
    n("Whiskey")
    // TRANSLATORS: A color name for RGB(211, 169, 103)
  ),
  new e(
    221,
    203,
    85,
    n("Gold")
  ),
  new e(
    165,
    184,
    114,
    n("Olivine")
    // TRANSLATORS: A color name for RGB(165, 184, 114)
  ),
  new e(
    110,
    166,
    143,
    n("Acapulco")
    // TRANSLATORS: A color name for RGB(110, 166, 143)
  ),
  new e(
    55,
    148,
    172,
    n("Boston Blue")
    // TRANSLATORS: A color name for RGB(55, 148, 172)
  ),
  new e(
    0,
    130,
    201,
    n("Nextcloud blue")
  ),
  new e(
    45,
    115,
    190,
    n("Mariner")
    // TRANSLATORS: A color name for RGB(45, 115, 190)
  ),
  new e(
    91,
    100,
    179,
    n("Blue Violet")
    // TRANSLATORS: A color name for RGB(91, 100, 179)
  ),
  new e(
    136,
    85,
    168,
    n("Deluge")
    // TRANSLATORS: A color name for RGB(136, 85, 168)
  )
];
function x(o) {
  if (o || (o = 6), o === 4)
    return g;
  const t = new e(182, 70, 157, n("Purple")), r = new e(221, 203, 85, n("Gold")), l = new e(0, 130, 201, n("Nextcloud blue")), a = i(o, t, r), c = i(o, r, l), u = i(o, l, t);
  return a.concat(c).concat(u);
}
export {
  x as G,
  g as d
};
